import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cboard.components.CommunicatorDialog.title',
    defaultMessage: 'My Communicator'
  },
  menu: {
    id: 'cboard.components.CommunicatorDialog.menu',
    defaultMessage: 'Menu'
  },
  menuRootBoardOption: {
    id: 'cboard.components.CommunicatorDialog.menuRootBoardOption',
    defaultMessage: 'Set as Root Board'
  },
  menuPublishOption: {
    id: 'cboard.components.CommunicatorDialog.menuPublishOption',
    defaultMessage: 'Publish Board'
  },
  menuUnpublishOption: {
    id: 'cboard.components.CommunicatorDialog.menuUnpublishOption',
    defaultMessage: 'Unpublish Board'
  },
  emptyBoardsList: {
    id: 'cboard.components.CommunicatorDialog.emptyBoardsList',
    defaultMessage: 'No boards :('
  },
  loadNextPage: {
    id: 'cboard.components.CommunicatorDialog.loadNextPage',
    defaultMessage: 'Load More'
  },
  search: {
    id: 'cboard.components.CommunicatorDialog.search',
    defaultMessage: 'Search'
  },
  author: {
    id: 'cboard.components.CommunicatorDialog.author',
    defaultMessage: 'By {author}'
  },
  addBoard: {
    id: 'cboard.components.CommunicatorDialog.addBoard',
    defaultMessage: 'Add Board'
  },
  removeBoard: {
    id: 'cboard.components.CommunicatorDialog.removeBoard',
    defaultMessage: 'Remove Board'
  },
  communicatorBoards: {
    id: 'cboard.components.CommunicatorDialog.communicatorBoards',
    defaultMessage: 'Boards'
  },
  allBoards: {
    id: 'cboard.components.CommunicatorDialog.allBoards',
    defaultMessage: 'Public Boards'
  },
  myBoards: {
    id: 'cboard.components.CommunicatorDialog.myBoards',
    defaultMessage: 'All My Boards'
  },
  boardsQty: {
    id: 'cboard.components.CommunicatorDialog.boardsQty',
    defaultMessage: '{qty} boards'
  },
  helpAndSupport: {
    id: 'cboard.components.CommunicatorDialog.helpAndSupport',
    defaultMessage: 'Help And Support'
  },
  termsOfService: {
    id: 'cboard.components.CommunicatorDialog.termsOfService',
    defaultMessage: 'Terms Of Service'
  },
  tilesQty: {
    id: 'cboard.components.CommunicatorDialog.tilesQty',
    defaultMessage: '{qty} Tiles'
  },
  boardInfo: {
    id: 'cboard.components.CommunicatorDialog.boardInfo',
    defaultMessage: 'Board Information'
  },
  boardAddedToCommunicator: {
    id: 'cboard.components.CommunicatorDialog.boardAddedToCommunicator',
    defaultMessage: 'Board successfully added to your Communicator'
  },
  boardRemovedFromCommunicator: {
    id: 'cboard.components.CommunicatorDialog.boardRemovedFromCommunicator',
    defaultMessage: 'Board successfully removed from your Communicator'
  },
  close: {
    id: 'cboard.components.CommunicatorDialog.close',
    defaultMessage: 'Close'
  },
  boardInfoName: {
    id: 'cboard.components.CommunicatorDialog.boardInfoName',
    defaultMessage: 'Board name'
  },
  boardInfoAuthor: {
    id: 'cboard.components.CommunicatorDialog.boardInfoAuthor',
    defaultMessage: 'Board Author'
  },
  boardInfoTiles: {
    id: 'cboard.components.CommunicatorDialog.boardInfoTiles',
    defaultMessage: 'Number of tiles'
  },
  boardInfoId: {
    id: 'cboard.components.CommunicatorDialog.boardInfoId',
    defaultMessage: 'Board ID'
  },
  boardInfoDate: {
    id: 'cboard.components.CommunicatorDialog.boardInfoDate',
    defaultMessage: 'Last edited'
  },
  boardDescription: {
    id: 'cboard.components.CommunicatorDialog.boardDescription',
    defaultMessage: 'Description'
  },
  boardPublished: {
    id: 'cboard.components.CommunicatorDialog.boardPublished',
    defaultMessage:
      'Board successfully published! Everybody can see your board now.'
  },
  boardUnpublished: {
    id: 'cboard.components.CommunicatorDialog.boardUnpublished',
    defaultMessage: 'Board was unpublished! Nobody can see your board now.'
  },
  boardDeleted: {
    id: 'cboard.components.CommunicatorDialog.boardDeleted',
    defaultMessage: 'Board was permanently deleted.'
  },
  rootBoard: {
    id: 'cboard.components.CommunicatorDialog.rootBoard',
    defaultMessage: 'Root Board'
  },
  publicBoard: {
    id: 'cboard.components.CommunicatorDialog.publicBoard',
    defaultMessage: 'Public Board'
  },
  privateBoard: {
    id: 'cboard.components.CommunicatorDialog.privateBoard',
    defaultMessage: 'Private Board'
  },
  activeBoard: {
    id: 'cboard.components.CommunicatorDialog.activeBoard',
    defaultMessage: 'Active Board'
  },
  copyBoard: {
    id: 'cboard.components.CommunicatorDialog.copyBoard',
    defaultMessage: 'Copy Board into your communicator'
  },
  copyBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.copyBoardDescription',
    defaultMessage:
      'This action will create a copy of the public board and will add it into your communicator. Do you want to proceed?'
  },
  deleteBoard: {
    id: 'cboard.components.CommunicatorDialog.deleteBoard',
    defaultMessage: 'Delete Board'
  },
  deleteBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.deleteBoardDescription',
    defaultMessage:
      'This action will delete the board and it cannot be recovered. Do you want to proceed?'
  },
  publishBoard: {
    id: 'cboard.components.CommunicatorDialog.publishBoard',
    defaultMessage: 'Board Description'
  },
  publishBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.publishBoardDescription',
    defaultMessage:
      'Please provide a short description about the content of the board and what is the board intended for.'
  },
  accept: {
    id: 'cboard.components.CommunicatorDialog.accept',
    defaultMessage: 'Accept'
  },
  imageBoard: {
    id: 'cboard.components.CommunicatorDialog.imageBoard',
    defaultMessage: 'Edit Board Image'
  },
  imageBoardDescription: {
    id: 'cboard.components.CommunicatorDialog.imageBoardDescription',
    defaultMessage: 'You can either upload or look for symbols from libraries.'
  },
  imageSearch: {
    id: 'cboard.components.CommunicatorDialog.imageSearch',
    defaultMessage: 'Search for symbols'
  },
  editBoardTitle: {
    id: 'cboard.components.CommunicatorDialog.editBoardTitle',
    defaultMessage: 'Edit board name and description'
  },
  editBoardTitleDescription: {
    id: 'cboard.components.CommunicatorDialog.editBoardTitleDescription',
    defaultMessage:
      'You can edit board name and description from here. Please consider to write a meaningful description for your board.'
  },
  noTitle: {
    id: 'cboard.components.CommunicatorDialog.noTitle',
    defaultMessage: 'No title'
  }
});
